<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-layout justify-end
                  class="mb-8">
            <v-btn color="secondary"
                   v-if="canAddStatus"
                   @click="openForm()"
                   data-test="addNewIncidentBtn">{{ $t('labels.add_incident_status') }}</v-btn>
        </v-layout>
        <v-data-table :headers="headers"
                      :loading="loader"
                      disable-sort
                      :items="incidentStatuses"
                      disable-pagination
                      hide-default-footer
                      class="elevation-1">
            <template v-for="(headerItem, i) in headers"
                      v-slot:[`header.${headerItem.value}`]="{ header }">
                <SortableHeader :header-item="header"
                                :key="i"
                                @sort="sort($event)"></SortableHeader>
            </template>
            <template v-slot:item.name="{ item }">
                <Type v-if="item.color"
                      :type="getType(item)"></Type>
                <span v-else>{{item.name}}</span>
            </template>
            <template v-slot:item.is_default="{ item }">
                <HintingIcon color="secondary"
                             v-if="item.is_default"
                             :icon="ICONS.CHECK_CIRCLE"
                             :tooltip="$t('labels.status')"></HintingIcon>
            </template>

            <template v-slot:item.actions="{ item }">
                <HintingIcon class-name="mr-2"
                             :icon="ICONS.EDIT"
                             v-if="canEditStatus"
                             @click="openForm(item.id)"
                             :data-test="item"
                             :tooltip="$t('actions.edit')"></HintingIcon>
                <ButtonWithConfirmation :item-id="item.id"
                                        v-if="canRemoveStatus"
                                        :callback="deleteStatus">
                </ButtonWithConfirmation>
            </template>
        </v-data-table>

        <Pagination :pagination="pagination"
                    data-test="pagination"
                    @change-page="changePage($event)"
                    @change-amount="changeAmount($event)"></Pagination>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { ICONS } from '@/constants/icons';
import SortableHeader from '@/components/widgets/tables/SortableHeader';
import HintingIcon from '@/components/widgets/HintingIcon';
import Pagination from '@/components/widgets/tables/Pagination';
import ButtonWithConfirmation from '@/components/widgets/buttons/ButtonWithConfirmation';
import Type from '@/components/widgets/Type';

export default {
    name: 'StatusesTable',
    components: { SortableHeader, HintingIcon, Pagination, ButtonWithConfirmation, Type },
    props: {
        loader: {
            type: Boolean,
            'default': false
        },
        changedPage: {
            type: [String, Number],
            required: false
        }
    },
    data: () => ({
        ICONS,
        pagination: {
            page: 1,
            amount: 20,
            amountAll: null
        },
        sortable: {
            name: 'asc',
            description: null,
            completion_percent: null,
            is_default: null
        }
    }),
    computed: {
        ...mapState('incidents', [
            'incidentStatuses',
            'totalIncidentStatusAmount'
        ]),
        headers () {
            return [
                {
                    text: this.$t('incidents.table.headers.seq'),
                    value: 'seq',
                    icon: false,
                    sortable: false
                },
                {
                    text: this.$t('labels.name'),
                    value: 'name',
                    icon: false,
                    sortable: true
                },
                {
                    text: this.$t('labels.description'),
                    value: 'description',
                    icon: false,
                    sortable: true
                },
                {
                    text: this.$t('labels.completion_percent'),
                    value: 'completion_percent',
                    icon: false,
                    sortable: true
                },
                {
                    text: this.$t('labels.default'),
                    value: 'is_default',
                    icon: false,
                    sortable: true
                },
                {
                    text: this.$t('incidents.table.headers.actions'),
                    value: 'actions',
                    icon: false,
                    width: '90px',
                    sortable: false
                }
            ];
        },
        canEditStatus () {
            return this.$can(this.$abilityActions.UPDATE, this.$abilitySubjects.INCIDENT_STATUS);
        },
        canAddStatus () {
            return this.$can(this.$abilityActions.CREATE, this.$abilitySubjects.INCIDENT_STATUS);
        },
        canRemoveStatus () {
            return this.$can(this.$abilityActions.DELETE, this.$abilitySubjects.INCIDENT_STATUS);
        }
    },
    watch: {
        totalIncidentStatusAmount: {
            handler (val) {
                this.pagination.amountAll = val;
            },
            immediate: true
        },
        changedPage: {
            handler (val) {
                if (val !== this.pagination.page) {
                    this.pagination.page = val;
                }
            }
        }
    },
    methods: {
        getType (item) {
            return {
                id: item.id,
                name: item.name,
                color: item.color
            };
        },
        changePage (event) {
            this.pagination.page = event;
            this.$emit('change-page', event);
        },
        changeAmount (event) {
            this.pagination.page = 1;
            this.pagination.amount = event;
            this.$emit('change-amount', event);
        },
        sort (event) {
            switch (this.sortable[event]) {
            case null:
                this.sortable[event] = 'desc';
                break;
            case 'asc':
                this.sortable[event] = 'desc';
                break;
            case 'desc':
                this.sortable[event] = 'asc';
                break;
            }

            this.$emit('sort', {
                name: event,
                value: this.sortable[event]
            });
        },
        openForm (id) {
            if (id) {
                this.$store.dispatch('manageIncident/getActiveIncidentStatus', id)
                    .then(() => {
                        this.$store.commit('manageIncident/SET_STATUS_FORM_VISIBILITY', true);
                        this.$store.commit('manageIncident/SET_ACTIVE_STATUS_ID', id);
                        this.editedIncidentStatusId = id;
                    });
            } else {
                this.$store.commit('manageIncident/SET_STATUS_FORM_VISIBILITY', true);
            }
        },
        deleteStatus (id) {
            return this.$store.dispatch('manageIncident/deleteIncidentStatus', id)
                .then(() => {
                    this.$emit('fetch');
                });
        }
    }
};
</script>

<style scoped>

</style>
